import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
const db = firebaseApp.database()

const latestAccessRef = db.ref('latestAccess')

export const latestAccessModule = {
  namespaced: true,
  state: {
    latestAccess: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    [getterConstants.GET_LATEST_ACCESS]: firebaseAction(({ bindFirebaseRef }) => {
      console.log('GET_LATEST_ACCESS:', latestAccessRef)
      bindFirebaseRef('latestAccess', latestAccessRef, { wait: true })
    }),
    [getterConstants.UNBIND_LATEST_ACCESS]: firebaseAction(({ bindFirebaseRef, unbindFirebaseRef }) => {
      unbindFirebaseRef('latestAccess')
    })
  },
  getters: {
    getLatestAccess: (state) => {
      let latestAccess = state.latestAccess || {}
      delete latestAccess['.key']
      return latestAccess
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/latestAccess.js